var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[(_vm.item?.box_types && _vm.item.box_types?.length)?_c('McChipList',{attrs:{"items":_vm.item.box_types,"max-visible":3,"itemTextField":"name","showAllMode":"dropdown","showAllDropdownTitle":_vm.$t('setting.list.product.field.boxType'),"showAllDropdownTrigger":"action"}}):_c('span',[_vm._v("-")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }